import {reduxStore} from '../ReduxIndex';

export function setGlobalSpinner(globalSpinner) {
    reduxStore.dispatch({
        type: 'setGlobalSpinner',
        payload: {
            globalSpinner,
        },
    });
}

export function setMenuData(newMenuData, submenu = null) {
    const {menuData} = reduxStore.getState().GeneralReducer;
    if (submenu) {
        menuData['lists'][1]['submenu'] = submenu;
    }
    reduxStore.dispatch({
        type: 'setMenuData',
        payload: {
            menuData: {...menuData, ...newMenuData},
        },
    });
}

export function setGlobalConfiguration(settings) {
    reduxStore.dispatch({
        type: 'setGlobalConfiguration',
        payload: {
            settings,
        },
    });
}
